import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CreateAccountForm } from '@gate31/feature/CreateAccountForm/CreateAccountForm';
import { ConfirmPhoneDesk } from '@gate31/desktop/components/ConfirmPhoneDesk/ConfirmPhoneDesk';
import { PasswordToggleDesk } from '../PasswordToggleDesk/PasswordToggleDesk';

export class CreateAccountFormDesk extends CreateAccountForm {
    static cn = new Base.BuildCn('CreateAccountFormDesk');

    constructor(options: {
        node: HTMLElement;
        source?: string;
        successHandle?: () => void;
    }) {
        super({
            node: options.node,
            source: options.source,
            cn: CreateAccountFormDesk.cn,
            successHandle: options.successHandle,
            configPhone: new ConfirmPhoneDesk(ConfirmPhoneDesk.querySelector(ConfirmPhoneDesk.cn.toSelector())),
            passwordToggler: new PasswordToggleDesk('password-toggle-desk-template')
        });
    }
}
